var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"sa-card sa-card-border",attrs:{"header":"Attività e Terapie","header-tag":"header","footer-tag":"footer","title":""}})}
var staticRenderFns = []

export { render, staticRenderFns }